<template>
    <div id="callbackTaskByLaws">
        <Headers :headersText='headersText'></Headers>

        <div class="boxPadding">
            <div class="byLawsPanel">
                <div class="title">*回调任务</div>
                <div>回调任务的操作步骤与快速任务基本一致，奖励的到账时间通常是即时到账或者5分钟内到账，极少但不排除有用户获取奖励失败，如果您按照任务要求完整完成了任务却没有得到奖励，请及时联系客服解决。</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../components/headersL'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'回调任务细则',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #callbackTaskByLaws{
        .boxPadding{
            padding: 8px 22px;
            .byLawsPanel{
                width:300px;
                height:115px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                padding: 15px;
                font-size:13px;
                color:#444444;
                line-height:21px;
                .title{
                    font-weight: 600;
                    color: #111111;
                }
            }
        }
    }
</style>